Vue.component('zadaj-pytanie', {
  template: '#vue-zadaj-pytanie',
  props: {
    offer: { default: '' }
  },
  data: function () {
    return {
      success: false,
      params: {
        nameAndSurname: {
          value: '',
          validation: ''
        },
        contents: {
          value: '',
          validation: ''
        },
        email: {
          value: '',
          validation: ''
        },
        emailRepeat: {
          value: '',
          validation: ''
        },
        phone: {
          value: '',
          validation: ''
        },
        agreement: {
          value: false,
          text: '',
          validation: ''
        }
      }
    }
  },
  mounted: function () {
    const self = this;

    setCanonicalTag('https://' + location.host + '/zadaj-pytanie');

    if (self.offer
      || agentx == "kompas2www"
      || agentx == "kompasoasis2www"
    ) {
      setMetaNoIndex(true);
    }

    self.getZgoda();
  },
  watch: {
    'params.nameAndSurname.value': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.validateEmptyInput('nameAndSurname');
      }
    },
    'params.email.value': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.validateEmptyInput('email');
        this.validateEmailInput();
      }
    },
    'params.emailRepeat.value': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.validateEmailInput();
      }
    },
    'params.agreement.value': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.validateAgreementInput();
      }
    }
  },
  methods: {
    getZgoda: function () {
      const self = this;

      $.post("/back/ZadajPytanie.php", { action: 'zgoda' }, function (result, textStatus) {
        if (result.agreement !== null) {
          self.params.agreement.text = result.agreement;
        }
        serverBus.$emit('loading_end');
      }, "json");
    },
    saveKatalog: function () {
      const self = this;

      if (self.validateForm()) {
        serverBus.$emit('loading_start');

        let offer = self.offer;
        if (offer != '') {
          offer = atou(offer);
        }

        let data = {
          nameAndSurname: self.params.nameAndSurname.value,
          email: self.params.email.value,
          emailRepeat: self.params.emailRepeat.value,
          contents: self.params.contents.value,
          phone: self.params.phone.value,
          agreement: self.params.agreement.value,
          offer: offer
        };
        $.post("/back/ZadajPytanie.php", { action: 'save', pytanie: data }, function (result, textStatus) {
          serverBus.$emit('loading_end');
          if (result.status == "OK") {
            self.success = true;
          } else {
            alert(result.details);
          }
        }, "json");
      }
    },
    validateForm: function () {
      const self = this;

      let emptyValidation = true;
      if (!self.validateEmptyInput('nameAndSurname')) {
        emptyValidation = false;
      }
      if (!self.validateEmptyInput('email')) {
        emptyValidation = false;
      }
      if (!self.validateAgreementInput()) {
        emptyValidation = false;
      }
      if (!emptyValidation) {
        return false;
      }
      if (!self.validateEmailInput()) {
        return false;
      }

      return true;
    },
    validateEmptyInput: function (name) {
      const self = this;
      if (self.params.hasOwnProperty(name)) {
        if (self.params[name].value == '') {
          self.params[name].validation = locales('components.zadaj-pytanie.js.error_empty');
          return false;
        } else {
          self.params[name].validation = "";
          return true;
        }
      }
    },
    validateEmailInput: function () {
      const self = this;
      if (self.validateEmailAddress(self.params.email.value) === false) {
        self.params.email.validation = locales('components.zadaj-pytanie.js.error_email');
        return false;
      } else {
        self.params.email.validation = "";
      }
      if (self.params.email.value != self.params.emailRepeat.value) {
        self.params.emailRepeat.validation = locales('components.zadaj-pytanie.js.error_email_repeat');
        return false;
      } else {
        self.params.emailRepeat.validation = "";
      }
      return true;
    },
    validateAgreementInput: function () {
      const self = this;
      if (self.params.agreement.value == false) {
        self.params.agreement.validation = locales('components.zadaj-pytanie.js.error_agreement');
        return false;
      } else {
        self.params.agreement.validation = "";
      }
      return true;
    },
    validateEmailAddress: function (email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }
});
